module.exports = __webpack_public_path__ + "img/gulflogo.905490ea.svg";